import { useState } from 'react';
import styled from 'styled-components';
import { getAuthData } from '../../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const StyledI = styled.i`
  color: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
`;

const StyledA = styled.a`
  &:hover {
    color: ${({ landingSecondaryColor }) => landingSecondaryColor} !important;
  }
`;

const StyledNav = styled.section`
  li.active a {
    color: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  }
  li:hover a {
    color: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  }
  a:before {
    background: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  }
`;

const StyledAButton = styled.a`
  background: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  &:before {
    background: ${({ landingSecondaryColor }) =>
      landingSecondaryColor} !important;
  }
`;

const StyledMenuIcon = styled.span`
  svg {
    font-size: 20px;

    color: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;

    :hover a {
      color: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
    }
  }
`;

const Header = ({
  appName,
  appLogo,
  appPhoneNumber,
  appEmailAddress,
  landingPrimaryColor,
  landingSecondaryColor,
}) => {
  const [show, setShow] = useState(false);
  const { isLoggedIn } = getAuthData();

  const toggleNavigation = () => setShow(!show);

  return (
    <header className="header" style={{ fontFamily: 'Poppins, sans-serif' }}>
      <div className="topbar">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-5 col-12"></div>
            <div className="col-lg-6 col-md-7 col-12">
              <ul className="top-contact">
                {appPhoneNumber && (
                  <li>
                    <StyledI
                      className="fa fa-phone"
                      landingPrimaryColor={landingPrimaryColor}
                    ></StyledI>
                    <StyledA
                      href={`tell:+91${appPhoneNumber}`}
                      landingPrimaryColor={landingPrimaryColor}
                      landingSecondaryColor={landingSecondaryColor}
                    >
                      <span className="__cf_email__">+91 {appPhoneNumber}</span>
                    </StyledA>
                  </li>
                )}
                {appEmailAddress && (
                  <li>
                    <StyledI
                      className="fa fa-envelope"
                      landingPrimaryColor={landingPrimaryColor}
                    ></StyledI>
                    <StyledA
                      href={`mailto:${appEmailAddress}`}
                      landingPrimaryColor={landingPrimaryColor}
                      landingSecondaryColor={landingSecondaryColor}
                    >
                      <span className="__cf_email__">{appEmailAddress}</span>
                    </StyledA>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="header-inner">
        <div className="container">
          <div className="inner">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-12">
                <div className="logo" style={{ padding: '10px', margin: 0 }}>
                  <a href="/">
                    {appName && (
                      <img
                        src={appLogo}
                        alt={appName}
                        style={{ maxHeight: '54px' }}
                      />
                    )}
                  </a>
                </div>
                <div class="mobile-nav">
                  <div class="slicknav_menu">
                    <a
                      href="#"
                      aria-haspopup="true"
                      role="button"
                      // style="outline: none;"
                      onClick={toggleNavigation}
                    >
                      <StyledMenuIcon
                        landingPrimaryColor={landingPrimaryColor}
                        landingSecondaryColor={landingSecondaryColor}
                      >
                        <FontAwesomeIcon icon={faBars} />
                      </StyledMenuIcon>
                    </a>
                  </div>
                </div>
              </div>
              {show && (
                <ul class="slicknav_nav slicknav_hidden">
                  <li>
                    <a href={isLoggedIn ? '/dashboard' : '/login'}>
                      {isLoggedIn ? `Account` : `Login/Register`}
                    </a>
                  </li>
                  <li className="active">
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href={`${window.location.origin}#services-link`}>
                      Services
                    </a>
                  </li>
                  <li>
                    <a href={`${window.location.origin}#about-link`}>
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href={`${window.location.origin}#contact-link`}>
                      Contact Us
                    </a>
                  </li>
                </ul>
              )}
              <div className="col-lg-7 col-md-9 col-12">
                <div className="main-menu">
                  <StyledNav
                    landingPrimaryColor={landingPrimaryColor}
                    landingSecondaryColor={landingSecondaryColor}
                  >
                    <nav className="navigation">
                      <ul className="nav menu">
                        <li className="active">
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href={`${window.location.origin}#services-link`}>
                            Services
                          </a>
                        </li>
                        <li>
                          <a href={`${window.location.origin}#about-link`}>
                            About Us
                          </a>
                        </li>
                        <li>
                          <a href={`${window.location.origin}#contact-link`}>
                            Contact Us
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </StyledNav>
                </div>
              </div>
              <div className="col-lg-2 col-12 account-button-to-top">
                <div className="get-quote">
                  <StyledAButton
                    href={isLoggedIn ? '/dashboard' : '/login'}
                    className="btn"
                    landingPrimaryColor={landingPrimaryColor}
                    landingSecondaryColor={landingSecondaryColor}
                  >
                    {isLoggedIn ? `Account` : `Login/Register`}
                  </StyledAButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
